import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = () => {
  const metrics = [
    {
      icon: 'Clock',
      value: '< 2h',
      label: 'Temps de réponse moyen',
      color: 'primary'
    },
    {
      icon: 'Users',
      value: '2,500+',
      label: 'Clients satisfaits',
      color: 'success'
    },
    {
      icon: 'Star',
      value: '4.9/5',
      label: 'Note moyenne',
      color: 'warning'
    },
    {
      icon: 'CheckCircle2',
      value: '98%',
      label: 'Taux de résolution',
      color: 'success'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Des performances qui parlent d'elles-mêmes
          </h2>
          <p className="text-lg text-muted-foreground">
            La satisfaction de nos clients est notre priorité
          </p>
        </div>
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics?.map((metric, index) => (
            <div 
              key={index}
              className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-lg transition-shadow"
            >
              <div className={`w-14 h-14 mx-auto mb-4 rounded-full bg-${metric?.color}/10 flex items-center justify-center`}>
                <Icon name={metric?.icon} size={28} className={`text-${metric?.color}`} />
              </div>
              <div className="text-3xl font-bold text-foreground mb-2">
                {metric?.value}
              </div>
              <div className="text-sm text-muted-foreground">
                {metric?.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PerformanceMetrics;